package ru.malygin.urls

import ru.malygin.urls.tech.UrlParams
import ru.malygin.urls.tech.urlServ
import ru.malygin.urls.url.GetAllDataFromDatabase
import ru.malygin.urls.url.GetDataByNameFromDatabase
import ru.malygin.urls.url.GetDataForFindTeacher
import ru.malygin.urls.url.GetScheduleChangeList


class UrlHandler(
    private val urlGetDataByNameFromDatabase: GetDataByNameFromDatabase = GetDataByNameFromDatabase(),
    private val urlGetAllDataFromDatabase: GetAllDataFromDatabase = GetAllDataFromDatabase(),
    private val urlGetScheduleChangeList: GetScheduleChangeList = GetScheduleChangeList(),
    private val urlGetDataForFindTeacher: GetDataForFindTeacher = GetDataForFindTeacher()
){
    private val tempBaseUrlServer = urlServ()

    val queryToken = "token"
    val queryGroupName = "group_name"
    val queryCategory = "category"

    val closeApiRoutingPath = UrlParams.Companion.ApiAccess.CLOSE.value+UrlParams.Companion.ApiVersion.V1.value
    val openApiRoutingPath = UrlParams.Companion.ApiAccess.OPEN.value+UrlParams.Companion.ApiVersion.V1.value

    /**
     * return data by name api path
     */
    fun getUrlDataByName(): UrlParams {
        return UrlParams(
            baseUrl = tempBaseUrlServer,
            apiPath = urlGetDataByNameFromDatabase.urlHead
        )
    }

    /**
     * return data for schedule change list api path
     */
    fun getScheduleChangeList():UrlParams{
        return UrlParams(
            baseUrl = tempBaseUrlServer,
            apiPath = urlGetScheduleChangeList.urlHead
        )
    }


    /**
     * return all data api path
     */
    fun getUrlAllData(): UrlParams {
        return UrlParams(
            baseUrl = tempBaseUrlServer,
            apiPath = urlGetAllDataFromDatabase.urlHead
        )
    }

    /**
     * return data for find teacher api path
     */
    fun getUrlFindTeacherData(): UrlParams {
        return UrlParams(
            baseUrl = tempBaseUrlServer,
            apiPath = urlGetDataForFindTeacher.urlHead
        )
    }
}
